import { NCNode, SynthesiseRecipeInput } from '../../../../src/commonTypes';

/**
 * Resolves recipe inputs that came from the board into live graph nodes.
 * Used to restore Synthesise selection highlights when the user re-enters
 * board-item selection mode.
 */
export const resolveRecipeBoardNodes = (
	inputs: SynthesiseRecipeInput[],
	getNode: (uid: string) => NCNode | undefined
): NCNode[] => {
	const seen = new Set<string>();
	const nodes: NCNode[] = [];
	for (const input of inputs) {
		if (input.source !== 'board' || !input.nodeUid || seen.has(input.nodeUid)) continue;
		const node = getNode(input.nodeUid);
		if (!node) continue;
		seen.add(input.nodeUid);
		nodes.push(node);
	}
	return nodes;
};

/**
 * Makes board-sourced recipe inputs mirror the live board selection exactly,
 * while preserving Idea Box, Notepad, and non-node context.
 */
export const reconcileRecipeBoardInputs = (
	inputs: SynthesiseRecipeInput[],
	selectedNodes: NCNode[],
	inputFromNode: (node: NCNode) => SynthesiseRecipeInput
): SynthesiseRecipeInput[] => {
	const selectedUids = new Set(selectedNodes.map((node) => node.uid));
	const nextInputs = inputs.filter(
		(input) => input.source !== 'board' || !input.nodeUid || selectedUids.has(input.nodeUid)
	);
	const includedUids = new Set(
		nextInputs.map((input) => input.nodeUid).filter((uid): uid is string => Boolean(uid))
	);
	for (const node of selectedNodes) {
		if (includedUids.has(node.uid)) continue;
		nextInputs.push(inputFromNode(node));
		includedUids.add(node.uid);
	}
	return nextInputs;
};
